module.exports = __webpack_public_path__ + "img/vegetable-green-onions-350x184.e9e6b422.jpg";